import { fetchOnce } from "~/common/utils/fetchOnce";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { LicenseFileType, LicenseFlagsBoolean } from "../types";

export const licenseApi = {
    get: fetchOnce(() => {
        return OAuthClient.postJson(appUrls.license.get).then(resp => resp);
    }) as F<PromiseLike<LicenseFileType>>,
    isEnabled(flag: LicenseFlagsBoolean): PromiseLike<boolean> {
        return this.get().then((license: LicenseFileType) => !!license.LicenseFlags?.[flag]);
    },
};
